module.exports = __webpack_public_path__ + "img/cases.5be6ebee.png";